import Vue from 'vue';
import _ from 'lodash';
import {ADD_TOAST_MESSAGE} from "vuex-toast";
import rankingApi from "../api/ranking";
import commonAPI from "../api/common"
import i18n from '../../i18n';

const types = {
  LOADING: 'LOADING',
  LOADING_BY_KEY: "LOADING_BY_KEY",
  GET_RANK_SUCCESS: 'GET_RANK_SUCCESS',
  GET_RANK_FAIL: 'GET_RANK_FAIL',
  GET_RANK_SECTOR_SUCCESS: 'GET_RANK_SECTOR_SUCCESS',
  GET_RANK_SECTOR_FAIL: 'GET_RANK_SECTOR_FAIL',
  GET_TOTAL_STOCKS_SUCCESS: 'GET_TOTAL_STOCKS_SUCCESS',
  GET_B_INDICATOR_SUCCESS: 'GET_B_INDICATOR_SUCCESS'
};

const mapSector = {
  ENE: 'energy',
  HEA: 'health',
  IND: 'industry',
  AGR: 'agri',
  FIN: 'fin',
  TEC: 'tech',
  REA: 'real',
  MAT: 'material',
  TEL: 'telecom',
  CON: 'consumer',
  UTI: 'utility',
  UNK: 'unknown'
};

// initial state
const initalState = {
  loading: false,
  form: {},
  rank: {},
  sectors: {},
  types: {},
  search: {},
  noOfStocks: 0,
};

// getters
const getters = {
  loading: state => state.loading,
  form: state => state.form,
  rank: state => state.rank,
  sectors: state => state.sectors,
  search: state => state.search,
  noOfStocks: state => state.noOfStocks,
  bIndicator: state => state.bIndicator
};

// actions
const actions = {
  async getSectors({ commit, dispatch }) {
    try {
      commit('LOADING_BY_KEY', { key: "rankSectorLoading", status: true });
      const { data } = await commonAPI(dispatch).getSectors();
      commit(types.GET_RANK_SECTOR_SUCCESS, data);
    } catch (e) {
      Vue.$log.error(i18n.t('messages.sectors_get_failed'), e);
      dispatch(
        ADD_TOAST_MESSAGE,
        { text: i18n.t('messages.sectors_get_failed'), type: "danger" },
        { root: true }
      );
      commit(types.GET_RANK_SECTOR_FAIL);
      commit('LOADING_BY_KEY', { key: "rankSectorLoading", status: false });
    }
  },

  async getRankingByType({ commit, dispatch }, params) {
    try {
      commit('LOADING_BY_KEY', { key: "rankFilterLoading", status: true });
      const { data } = await rankingApi(dispatch).getRankingByType(params.type, params.params);
      commit(types.GET_RANK_SUCCESS, data);
    } catch (e) {
      Vue.$log.error(i18n.t('messages.ranking_get_failed'), e);
      dispatch(
        ADD_TOAST_MESSAGE,
        { text: i18n.t('messages.ranking_get_failed'), type: "danger" },
        { root: true }
      );
      // commit(types.GET_RANK_FAIL);
      // commit('LOADING_BY_KEY', { key: "rankLoading", status: false });
    }
  },
};

// mutations
const mutations = {
  [types.LOADING](state, loading) {
    state.loading = loading;
  },

  [types.LOADING_BY_KEY](state, data) {
    Vue.set(state.form, data.key, data.status);
  },

  [types.GET_TOTAL_STOCKS_SUCCESS](state, data) {
    Vue.set(state, 'noOfStocks', data);
  },

  [types.GET_B_INDICATOR_SUCCESS](state, data) {
    Vue.set(state, 'bIndicator', data);
  },

  [types.GET_RANK_SUCCESS](state, data) {
    Vue.set(state, 'rank', data);
    Vue.set(state.form, 'rankLoading', false);
    Vue.set(state.form, 'rankFilterLoading', false);
  },

  [types.GET_RANK_FAIL](state) {
    Vue.set(state.form, 'rankLoading', false);
  },

  [types.GET_RANK_SECTOR_SUCCESS](state, data) {
    const options = data.map(item => ({
      value: item.code,
      text: i18n.t(`sector_types.${mapSector[item.code]}`)
    }));
    Vue.set(state, 'sectors', options);
    Vue.set(state.form, 'rankSectorLoading', false);
  },

  [types.GET_RANK_SECTOR_FAIL](state) {
    Vue.set(state.form, 'rankSectorLoading', false);
  },
};

export default {
  namespaced: true,
  state: initalState,
  getters,
  actions,
  mutations,
};
